<div class="hpanel margin-bottom-5 gs-widget-card">
  <div class="panel-body b-r-6 gs-widget-body">
    <div class="row">
      <div class="col-lg-12" *ngIf="!loadAPIcall">
        <div class="profile-first">
          <!-- When user has a photo -->
          <div *ngIf="ProfileComplete?.photo && ProfileComplete?.photo !== 'null' && ProfileComplete?.photo !== ''" class="profile-img">
            <circle-progress [percent]="ProfileComplete?.completePercentage" [radius]="100" [outerStrokeWidth]="8"
              [outerStrokeColor]="'#34495e'" [innerStrokeColor]="'#ffffff'" [animation]="true" [animationDuration]="300"
              [showImage]="true" [showBackground]="true" [imageSrc]="ProfileComplete?.photo" [responsive]="true"
              [space]="3" data-toggle="tooltip" data-placement="top" title="{{ ProfileComplete?.completePercentage }}"
              (click)="route(ProfileComplete?.userId)" class="user-profile">
            </circle-progress>
            <div class="progress-percentage-below">
              {{ ProfileComplete?.completePercentage }}% Complete
            </div>
          </div>
          <!-- When user has no photo - show initials overlay -->
          <div *ngIf="!ProfileComplete?.photo || ProfileComplete?.photo === 'null' || ProfileComplete?.photo === ''" class="profile-img profile-img-with-initials">
            <div class="circle-initials-wrapper">
              <circle-progress [percent]="ProfileComplete?.completePercentage" [radius]="100" [outerStrokeWidth]="8"
                [outerStrokeColor]="getTextColor(ProfileComplete?.firstName, ProfileComplete?.lastName)"
                [innerStrokeWidth]="0" [showImage]="false" [showBackground]="false" [showTitle]="false"
                [showSubtitle]="false" [showUnits]="false" [responsive]="true" [space]="3">
              </circle-progress>
              <div class="initials-overlay"
                [style.background-color]="getColor(ProfileComplete?.firstName, ProfileComplete?.lastName)"
                (click)="route(ProfileComplete?.userId)">
                <span class="initials-text" [style.color]="getTextColor(ProfileComplete?.firstName, ProfileComplete?.lastName)">
                  {{ getInitials(ProfileComplete?.firstName, ProfileComplete?.lastName) }}
                </span>
              </div>
            </div>
            <div class="progress-percentage-below">
              {{ ProfileComplete?.completePercentage }}% Complete
            </div>
          </div>
        </div>

        <div class="profile-info">
          <div class="profile-name text-ellipses-1 curpoint" (click)="route(ProfileComplete?.userId)"
            data-toggle="tooltip" data-placement="top"
            title="{{ ProfileComplete?.firstName }} {{ ProfileComplete?.lastName }}">
            {{ ProfileComplete?.firstName }} {{ ProfileComplete?.lastName }}
          </div>
          <div class="profile-title text-ellipses-1" data-toggle="tooltip" data-placement="top"
            title="{{ ProfileComplete?.title }} @{{ organizationname}}">
            {{ currentOrgProvider?.getCurrentOrg?.title }} <span *ngIf="currentOrgProvider?.getCurrentOrg?.organisationName">&#64;</span> {{ currentOrgProvider?.getCurrentOrg?.organisationName }}
          </div>


          <div class=" profile-title text-ellipses-1" data-toggle="tooltip" data-placement="top"
            title="{{ ProfileComplete?.city }}{{ProfileComplete?.state}}">
            {{ ProfileComplete?.city }}<span *ngIf="ProfileComplete?.city">{{ ", "}}</span>{{ ProfileComplete?.state }}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
